class ProgramCost {
	constructor(dom) {
		this.NAME = "ProgramCost";
		this.dom = dom;
	}

	init() {
		this.dom.querySelectorAll("[data-cost-note-toggle]").forEach((toggle) => {
			toggle.addEventListener("click", () => this.toggle(toggle));
		});
	}

	toggle(toggle) {
		const wrap = toggle.closest("[data-cost-note-wrap]");
		if (!wrap) return;

		wrap.classList.add("is-expanded");
		toggle.setAttribute("aria-expanded", "true");
	}
}

export default ProgramCost;
